import { createAction, props } from '@ngrx/store';
import { Update } from '@ngrx/entity';
import {
  IOrder,
  IOrderLineItem,
  IOrderDTO,
  LoadType,
  IGetOrdersQuery,
  Prescription,
  OrderDirection,
  IGetOrdersDTO,
  OrderPrescriptionType,
  IFailedWorkflowRunSummary
} from '@care-portals/api-interfaces';

export const clearActiveOrder = createAction('[Orders] Clear Active Order');

export const loadOrder = createAction(
  '[Orders] Load Order',
  props<{ orderId: number }>()
);

export const loadOrderSuccess = createAction(
  '[Orders] Load Order Success',
  props<{ order: IOrder }>()
);

export const loadOrderFailure = createAction(
  '[Orders] Load Order Failure',
  props<{ error: any }>()
);

export const retriggerOrder = createAction(
  '[Orders] Retrigger Order',
  props<{ orderId: number }>()
);

export const retriggerOrderSuccess = createAction(
  '[Orders] Retrigger Order Success',
  props<{ order: IOrder }>()
);

export const retriggerOrderFailure = createAction(
  '[Orders] Retrigger Order Failure',
  props<{ error: any }>()
);

export const retriggerPayment = createAction(
  '[Orders] Retrigger Payment',
  props<{ orderId: number }>()
);

export const retriggerPaymentSuccess = createAction(
  '[Orders] Retrigger Payment Success',
  props<{ order: IOrder }>()
);

export const retriggerPaymentFailure = createAction(
  '[Orders] Retrigger Payment Failure',
  props<{ error: any }>()
);

export const loadOrderPrescriptionSuccess = createAction(
  '[Orders] Load Order Prescription Success',
  props<{
    order: IOrder;
    rxResults: {
      prescriptions: Prescription[];
      type: OrderPrescriptionType;
    };
    failedWorkflowRuns: IFailedWorkflowRunSummary[];
  }>()
);

export const loadOrderPrescriptionFailure = createAction(
  '[Orders] Load Order Prescription Failure',
  props<{ error: any }>()
);

export const loadOrders = createAction(
  '[Orders] Load Orders',
  props<{
    loadType?: LoadType;
    filters: IGetOrdersQuery | IGetOrdersDTO;
    openNext?: boolean;
    openPrevious?: boolean;
  }>()
);

export const loadOrdersSuccess = createAction(
  '[Orders] Load Orders Success',
  props<{
    loadType?: LoadType;
    orders: IOrder[];
    totalCount?: number;
    filters?: IGetOrdersQuery | IGetOrdersDTO;
    limit?: number;
    offset?: number;
    hasMore: boolean;
  }>()
);

export const loadOrdersFailure = createAction(
  '[Orders] Load Orders Failure',
  props<{ error: any }>()
);

export const createOrder = createAction(
  '[Orders] Create Order',
  props<{
    orderItems: IOrderLineItem[];
    customerId: string;
    isRefill: boolean;
    delayedCapture?: boolean;
    sendEvent?: boolean;
  }>()
);

export const createOrderSuccess = createAction(
  '[Orders] Create Order Success',
  props<{ order: any }>()
);

export const createOrderFailure = createAction(
  '[Orders] Create Order Failure',
  props<{ error: any }>()
);

export const clearOrderResult = createAction('[Orders] Clear Order Result');

export const updateOrder = createAction(
  '[Orders] Update Order',
  props<{ orderId: number; data: IOrderDTO }>()
);

export const updateOrderSuccess = createAction(
  '[Orders] Update Order Success',
  props<{ update: Update<IOrder> }>()
);

export const updateOrderFailure = createAction(
  '[Orders] Update Order Failure',
  props<{ error: any }>()
);

export const switchOrder = createAction(
  '[Orders] Switch Order',
  props<{ direction: OrderDirection }>()
);

export const switchOrderSuccess = createAction(
  '[Orders] Switch Order Success',
  props<{ order: IOrder }>()
);

export const updateOrderPrescription = createAction(
  '[Orders] Update Order Prescription',
  props<{ orderId: string; prescription: Prescription }>()
);

export const updateOrderPrescriptionSuccess = createAction(
  '[Orders] Update Order Prescription Success',
  props<{ orderId: string; prescription: Prescription }>()
);

export const updateOrderPrescriptionFailure = createAction(
  '[Orders] Update Order Prescription Failure',
  props<{ error: any }>()
);

export const chargeOrder = createAction(
  '[Orders] Charge Order',
  props<{ orderId: string; customerId: string }>()
);

export const chargeOrderSuccess = createAction(
  '[Orders] Charge Order Success',
  props<{ orderId: string }>()
);

export const chargeOrderFailure = createAction(
  '[Orders] Charge Order Failure',
  props<{ orderId: string; error: any }>()
);

export const exportOrders = createAction(
  '[Orders] Export Orders',
  props<{ filters: IGetOrdersDTO }>()
);

export const exportOrdersSuccess = createAction(
  '[Orders] Export Orders Success',
  props<{ orders: IOrder[] }>()
);

export const exportOrdersFailure = createAction(
  '[Orders] Export Orders Failure',
  props<{ error: any }>()
);
